
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { PsychologistCardData } from './types';

interface PsychologistCardLanguagesProps {
  psychologist: PsychologistCardData;
}

const PsychologistCardLanguages: React.FC<PsychologistCardLanguagesProps> = ({ psychologist }) => {
  if (!psychologist.languages || psychologist.languages.length === 0) return null;
  
  const displayLanguages = psychologist.languages.slice(0, 2);
  const remainingCount = psychologist.languages.length - 2;

  return (
    <div className="mb-4">
      <h4 className="text-sm font-medium text-gray-700 mb-2">Idiomas:</h4>
      <div className="flex flex-wrap gap-1">
        {displayLanguages.map((language, index) => (
          <Badge
            key={index}
            className="bg-purple-500 hover:bg-purple-600 text-white text-xs px-3 py-1"
          >
            {language}
          </Badge>
        ))}
        {remainingCount > 0 && (
          <Badge className="bg-purple-500 hover:bg-purple-600 text-white text-xs px-3 py-1">
            +{remainingCount}
          </Badge>
        )}
      </div>
    </div>
  );
};

export default PsychologistCardLanguages;
